<template>
    <div class="collapsible" id="fournitures" :class="stateClass">

        <div class="collapsible-head wrap" id="head-fournitures"
             @click="$emit('openCollapsible','fournitures')">
            FOURNITURES
            <i class="icon-go"></i>
        </div>
        <div class="collapsible-body wrap" id="lst-fournitures">
            <ul class="list-pieces">
                <li v-for="f in fournitures" :key="f.id" class="piece">
                    <div class="identification">
                        <strong>{{ f.designation }}</strong>&nbsp;
                        <span v-if="f.etat">({{ f.etat }})</span>
                    </div>
                    <div class="price">{{ f.qte }} <span v-if="f.prix">x {{ f.prix }}€ HT</span></div>
                    <a href="javascript: void 0" class="btn delete" @click="deletePiece(f.id)">
                        <i class="icon-delete"></i>
                    </a>
                </li>
            </ul>
            <a href="javascript: void 0;" id="add-piece" @click="addPiece" class="btn add-manip">
                Ajouter une fourniture
                <i class="icon-add"></i>
            </a>
        </div>
    </div>
</template>
<script>
    import Piece from '../../../../js/models/Piece'

    export default {

        data(){
            return {
                fournitures: []
            }
        },

        props:{
            open: null,
            pieces : {
                type: Array,
                default: []
            },
        },

        methods: {

            addPiece() {

                let form = `<div class="add-piece-swal">
                                <label>Désignation</label>
                                <input type="text" id="designation" required="required" maxlength="255" />
                                <label>Etat</label>
                                <select id="etat-piece">
                                    <option value="" selected></option>
                                    <option>Forfait</option>
                                    <option>Pièce à commander</option>
                                    <option>Pièce remplacée</option>
                                </select>
                                <div class="colform">
                                    <label>Quantité</label>
                                    <input type="number" min="0" id="qte-piece">
                                </div>
                                <div class="colform">
                                    <label>Prix unitaire € (HT)</label>
                                    <input type="number" min="0" step="0.01" id="prix-piece">
                                </div>
                                <div class="clear"></div>
                            </div>`;

                swal({
                    title: "Ajout d'une fourniture",
                    html : form,
                    focusConfirm: false,
                    confirmButtonText:'Ajouter',
                    preConfirm: () => {

                        return new Promise((resolve, reject) => {

                            let designation = document.getElementById('designation').value;
                            let etat = document.getElementById('etat-piece').value;
                            let qte = document.getElementById('qte-piece').value;
                            let prix = document.getElementById('prix-piece').value;

                            if( qte &&  designation){

                                resolve({
                                    id: 'P-'+ +new Date(),
                                    fiche: this.$route.params.id,
                                    designation,
                                    etat,
                                    qte,
                                    prix
                                })

                            } else {
                                reject('Formulaire incomplet')
                            }

                        })

                    }
                }).then(res => {

                    this.fournitures.push(res);
                    Piece
                        .addOffline(res)
                        .then(() => {
                            this.$emit('updatePieces', this.fournitures)
                        })
                        .catch()

                })
            },

            async deletePiece(id) {
                try {
                    await swal({
                        title: 'Supprimer la fourniture ?',
                        text: 'Cette action est irréversible.',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Supprimer',
                        cancelButtonText: 'Annuler',
                        confirmButtonColor: '#d33',
                    });
                } catch (e) {
                    return;
                }

                Piece
                    .remove(id)
                    .then(() => {
                        this.fournitures = _.remove(this.fournitures, f => f.id !== id );
                        this.$emit('updatePieces', this.fournitures)
                    })
                    .catch()

            },

            // AJOUTE UNE FOURNITURE DÉJÀ CONSTRUITE (VALIDÉE DEPUIS LA MODALE D'EXTRACTION VOCALE)
            addValidatedPiece(piece) {
                this.fournitures.push(piece);
                Piece
                    .addOffline(piece)
                    .then(() => {
                        this.$emit('updatePieces', this.fournitures)
                    })
                    .catch()
            },

            fetchPieces() {

                let idFiche = this.$route.params.id;

                Piece
                    .getListForFiche(idFiche)
                    .then(res => this.fournitures = res)
                    .catch()

            }

        },

        mounted(){

            this.fetchPieces()

        },

        computed: {

            stateClass() {
                if (this.open === 'fournitures') {
                    return 'open'
                } else {
                    return ''
                }
            }

        }

    }
</script>
<style>

    #add-piece {
        background-color: #5698d2;
        color: #fff;
        width:230px;
        margin:15px 0;
        padding-left: 15px;
    }

    .add-piece-swal label {
        text-align: left;
    }

    li.piece {
        display: flex;
        border-bottom: 1px solid #cccccc;
        padding: 15px 0;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 1.5rem;
    }

    li.piece:last-child {
        border-bottom: none;
    }

    li.piece .price {
        margin-left: auto;
        background-color: #cccccc;
        border-radius: 5px;
        padding: 5px;
    }

    li.piece a.delete {
        margin-left:15px;
        width:40px;
        height:40px;
        color: #fff;
        background-color: #c31616;
    }

    li.piece a.delete i {
        font-size: 2.3rem;
        width: 38px;
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// GestionPieces.vue?039d074c